import { render, staticRenderFns } from "./CreateOrEdit.vue?vue&type=template&id=18671bd9&scoped=true&"
import script from "./CreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./CreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrEdit.vue?vue&type=style&index=0&id=18671bd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18671bd9",
  null
  
)

export default component.exports